import { memo, useCallback } from 'react';
import { StackNavigationProp, useNavigation } from '@bonanza-social/navigation';
import { Box, Icon, PressableOverlay, Text } from '@bonanza-social/moonlight';
import { FilterProps } from './Filter.types';

function Filter({ locKey, locNS, icon, onPress }: FilterProps) {
  const navigation =
    useNavigation<StackNavigationProp<AppNavigatorParamsList>>();

  const handlePress = useCallback(() => {
    onPress(navigation);
  }, [onPress, navigation]);

  return (
    <Box
      flexDirection="row"
      alignItems="center"
      marginHorizontal="space-100"
      paddingHorizontal="space-200"
      backgroundColor="mutedBackground"
      borderRadius="radius-600"
      alignSelf="flex-start"
      gap="space-100"
      height={36}
    >
      {icon && <Icon name={icon} gradient="accentBackground" />}
      <Text
        variant="caption-semi"
        locKey={locKey}
        locNS={locNS}
        color="darkSurfacePrimary"
      />
      <PressableOverlay onPress={handlePress} testID={`filter-${locKey}`} />
    </Box>
  );
}

export default memo(Filter);
